"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkerResponseName = exports.WorkerRequestName = void 0;
var WorkerRequestName;
(function (WorkerRequestName) {
    WorkerRequestName["PushWebLog"] = "__PUSH_WEB_LOG__";
    WorkerRequestName["PushHeartBeat"] = "__PUSH_HEART_BEAT__";
    WorkerRequestName["DefineMetadata"] = "__DEFINE_METADATA__";
    WorkerRequestName["SetConfig"] = "__SET_CONFIG__";
    WorkerRequestName["SetInterval"] = "__SET_INTERVAL__";
    WorkerRequestName["OnGetCheckSum"] = "__ON_GET_CHECKSUM__";
})(WorkerRequestName = exports.WorkerRequestName || (exports.WorkerRequestName = {}));
var WorkerResponseName;
(function (WorkerResponseName) {
    WorkerResponseName["GetChecksum"] = "__GET_CHECKSUM__";
})(WorkerResponseName = exports.WorkerResponseName || (exports.WorkerResponseName = {}));
